import {
  useTicketStatuses,
  UseTicketStatusesReturn,
} from 'src/pages/ServiceRequest/CustomHooks/useTicketStatuses';
import { buildStatusLabelResolver } from './displayStatusLabel';

export const useStatusLabelResolver = (): ((name: string) => string) => {
  const { ticketStatuses }: UseTicketStatusesReturn = useTicketStatuses();

  return buildStatusLabelResolver(ticketStatuses);
};
